<div
  fxLayout
  *ngIf="{
    thermostatPresets: thermostatPresets$ | async,
    hasWriteAccess: hasWriteAccess$ | async
  } as vm">
  <sbnb-subnav fxFlex="280px" fxHide.lt-md header="Thermostat Presets">
    <sbnb-devices-subnav></sbnb-devices-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists page-device-setup" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-content-header
      title="Thermostat Presets"
      [saveButtonShown]="false"
      [sticky]="false"
      novaContentId="smart-devices-thermostat-presets"></sbnb-content-header>

    <!-- <div fxLayout fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
      <div class="px-6 py-4 w-full">
        <div class="flex justify-end gap-4">
          <sbnb-search-bar
            placeholderText="Search..."
            (searchChanged)="onThermostatPresetsSearchChanged($event)"></sbnb-search-bar>
          <sbnb-button label="+ Add Preset" size="mini" (clicked)="addPreset()"></sbnb-button>
        </div>
      </div>
    </div> -->

    <div
      fxLayout
      fxLayoutAlign="end start"
      fxLayout.lt-md="column"
      fxLayoutGap="12px"
      fxLayoutAlign.lt-md="start stretch">
      <sbnb-search-bar
        fxFlex="480px"
        fxFlex.lt-md="100%"
        placeholderText="Search..."
        (searchChanged)="onThermostatPresetsSearchChanged($event)"></sbnb-search-bar>

      <sbnb-button
        label="+ Add Preset"
        size="mini"
        [loading]="(addingNew$ | async) === true"
        (clicked)="addPreset()"></sbnb-button>
    </div>

    <!-- Loading -->
    <mat-spinner *ngIf="vm.thermostatPresets.loading" [diameter]="24"></mat-spinner>

    <!-- Error -->
    <div *ngIf="vm.thermostatPresets.error" class="error">{{ vm.thermostatPresets.error }}</div>

    <!-- No items -->
    <div
      *ngIf="vm.thermostatPresets.data?.length === 0 && !vm.thermostatPresets.loading && !vm.thermostatPresets.error"
      class="error">
      <sbnb-no-items text="No thermostat presets found"></sbnb-no-items>
    </div>

    <sbnb-smart-device-thermostat-presets-table
      *ngIf="vm.thermostatPresets.data?.length > 0"
      [presets]="vm.thermostatPresets.data"
      [canAction]="vm.hasWriteAccess"></sbnb-smart-device-thermostat-presets-table>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Thermostat Presets">
  <sbnb-devices-subnav></sbnb-devices-subnav>
</sbnb-mobile-sidebar>
